import React from 'react';
import PropTypes from 'prop-types';
import request from '../../utils/agent';
import Loader from 'components/Loader';
import { Formik, Field, FieldArray, Form } from 'formik';
import * as Yup from 'yup';


export default class DistributorProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userD: { },
            companyD: { },
            cData: { },
            userLoaded: false,
            compLoaded: false,
            cDataLoaded: false,
            updateFlag: false,
            editingProfile: false,
            isError: false,
            uploadingCertificate: false,
            geo: null,
            lat: null,
            long: null,
            address_status: "",
            address: "",
            city: "",
            postal: "",
            country: "",
            state: "",
            touched: {
                address: false,
                city: false,
                postal: false,
                country: false,
                state: false,
            }
        };
    }


    editProfile = () => {
        this.setState({editingProfile: !this.state.editingProfile});
    };

    componentDidMount() {
        this.getUserData();
        this.getCompanyData();
        this.getcData();
    }

    componentDidUpdate() {
        if(this.state.updateFlag === true) {
            this.getUserData();
            this.getCompanyData();
            this.getcData();
            this.setState({
                updateFlag: false,
                editingProfile: false
            });
        }
        if(this.state.editingProfile === true) {
            this.addressListener();
        }
    }

    addressListener = (setFieldValue) => {
        const autocompleteFormField = document.getElementById(`addressAutocomplete.street`);

        const autocomplete = new google.maps.places.Autocomplete((autocompleteFormField), {
            types: [`address`]
        });

        google.maps.event.addListener(autocomplete, `place_changed`, () => {
            const place = autocomplete.getPlace();
            let ac = place.address_components;
            var address = {
                country: ac.filter(c => ~c.types.indexOf('country'))[0].short_name,
                street: place.name,
                city: ac.filter(c => ~c.types.indexOf('locality'))[0].long_name,
                state: ac.filter(c => ~c.types.indexOf('administrative_area_level_1'))[0].short_name,
                postal: ac.filter(c => ~c.types.indexOf('postal_code'))[0].short_name
            };

            //console.log(address); // This is our address selected component

            // I don't know how you would pass these to Formik.
            for(let key in address) {
                try {
                    document.getElementById(`addressAutocomplete.${key}`).value = address[key];
                    this.setState({
                        address: address.street,
                        city: address.city,
                        postal: address.postal,
                        country: address.country,
                        state: address.state,
                    })
                } catch(e) {
                    console.log(`Unable to set addressAutocomplete.${key}:${address[key]}`);
                }
            }

        });
    };

    handleAdrChange = (e) => {
        e.preventDefault();
        this.setState({
            address: e.target.value,
        })
    };
    handleCountryChange = (e) => {
        e.preventDefault();
        this.setState({
            country: e.target.value,
        })
    };
    handleCityChange = (e) => {
        e.preventDefault();
        this.setState({
            city: e.target.value,
        })
    };
    handleStateChange = (e) => {
        e.preventDefault();
        this.setState({
            state: e.target.value,
        })
    };
    handlePostalChange = (e) => {
        e.preventDefault();
        this.setState({
            postal: e.target.value,
        })
    };

    handleAdrBlur = (fieldName) => (e) => {
        this.setState({
            touched: {
                ...this.state.touched, [fieldName]: true
            },
        })
    };

    validateAdr(address, city, state, postal, country){
        return {
            address: address.length === 0,
            city: city.length === 0,
            state: state.length === 0,
            postal: postal.length === 0,
            country: country.length === 0,
        };
    };

    handleSubmitErr(e) {
        e.preventDefault();
        this.setState({
            touched: {
                address: true,
                city: true,
                postal: true,
                country: true,
                state: true,
            }
        })
    };

    getUserData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({
                        userD: resp.body.user,
                        userLoaded: true
                    });
                    //console.log('us', resp.body.user);
                    resolve(resp.body);
                });

        });
    };

    getcData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({
                        cData: resp.body.user.cdata,
                        cDataLoaded: true
                    });
                    resolve(resp.body);
                });
        });
    };

    getCompanyData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/company')
                .then(resp => {
                    this.setState({
                        companyD: resp.body.company,
                        compLoaded: true,
                        address: resp.body.company.address,
                        city: resp.body.company.city,
                        postal: resp.body.company.postal,
                        country: resp.body.company.country,
                        state: resp.body.company.state,
                    });
                    resolve(resp.body);
                });

        });
    };

    uploadResellerCertificate = () => {
        this.refs.onUploadUserFile.click();
        this.__FILETYPE__ = 'certificate';
        this.setState({uploadingCertificate: true});
    }

    onUploadUserFile = async (evt) => {
        this.__FILE__ = evt.target.files;

        const formData = new FormData();
        // Save our new file name as `profile-ID.EXT`

        let epox = (new Date).getTime();
        if(this.state.companyD.reseller_certification_path !== undefined && this.state.companyD.reseller_certification_path !== "null") {
            const splitted = this.state.companyD.reseller_certification_path.split('/');
            const uniC =  splitted[splitted.length-1].replace(/[^0-9]/g, '');
           // console.log('uniCert', uniC);
            epox = uniC;
        }

        //console.log('epox', epox)

        let fileName = `${this.__FILETYPE__}-${epox}.${this.__FILE__[0].name.split('.').pop()}`
        formData.append('file', this.__FILE__[0], fileName);
        let location = await request.post(`/api/user/upload/${this.__FILETYPE__}`)
            .send(formData)
            .then(resp => {
                //console.log(resp);
                return resp.body.Location;
            })
            .catch(err => {
                console.log(err);
                this.__FILE__ = null;
                this.__FILETYPE__ = null;
            });

        console.log('done uploading');
        let field = this.__FILETYPE__ === 'profile' ? 'logo_path' : 'reseller_certification_path';
        let payload = {
            [field]: location
        };
        this.updateCompany(payload);
    }

    updateCompany = (payload) => {
        request.put(`/api/company/${this.state.companyD.id}`)
            .send(payload)
            .then(resp => {
                this.setState({
                    companyD: resp.body.update_company,
                    uploadingProfile: false,
                    uploadingCertificate: false
                });
            })
            .catch(err => {
                console.log(err);
            });
    };

    handleVerifyAddress = async(address, city, state, postal, country) => {
        //evt.preventDefault();
        let geoloc = await request.post(`/api/company/address/coordinates`)
            .send ({"address": {"address": address, "country": country, "city": city, "state": state, "postal": postal}
            })
            .then(resp => {
                //console.log('response',resp.body.geospatial);
                return resp.body;
            })
            .catch(err => {
                console.log(err);
            });

        //console.log('geoloc', geoloc);
        if (geoloc !== undefined) {
            this.setState({
                geo: geoloc.geospatial,
                lat: geoloc.latitude,
                long: geoloc.longitude,
                address_status: "valid",
            })
        }

    };

    render() {


        const errors = this.validateAdr(this.state.address, this.state.city, this.state.state, this.state.state, this.state.country);
        //console.log('errors', errors);

        const isDisabled = Object.keys(errors).some(x => errors[x]);
        //console.log('isDisabled', isDisabled);

        //console.log('touched', this.state.touched);

        const shouldShowError = (fieldName) => {
            const hasErr = errors[fieldName];
            const shouldShow = this.state.touched[fieldName];
            return hasErr ? shouldShow : false;
        };



        //console.log('street address state', this.state.address);
        //console.log('city state', this.state.city);
        //console.log('postal state', this.state.postal);
        //console.log('country state', this.state.country);
        //console.log('state state', this.state.state);

        const countryOpts = [
            {id: '', display: 'Select Country'},
            {id: 'US', display: 'USA'},
            {id: 'CA', display: 'Canada'},
        ];

        const caStateOpts = [
            {id: '', display: 'Select State'},
            { id: 'AL', display: 'Alberta'},
            { id: 'BC', display: 'British Columbia'},
            { id: 'MA', display: 'Manitoba'},
            { id: 'NB', display: 'New Brunswik'},
            { id: 'NL', display: 'Newfoundlend and Labrador'},
            { id: 'NS', display: 'Nova Scotia'},
            { id: 'ON', display: 'Ontario'},
            { id: 'PEI', display: 'Price Edward Island'},
            { id: 'QU', display: 'Quebeck'},
            { id: 'SA', display: 'Saskatchewan'},
        ];

        const usStateOpts = [
            {id: '', display: 'Select State'},
            { id: 'AL', display: 'Alabama'},
            { id: 'AK', display: 'Alaska'},
            { id: 'AZ', display: 'Arizona'},
            { id: 'AR', display: 'Arkansas'},
            { id: 'CA', display: 'California'},
            { id: 'CO', display: 'Colorado'},
            { id: 'CT', display: 'Connecticut'},
            { id: 'DC', display: 'District of Columbia'},
            { id: 'DE', display: 'Delaware'},
            { id: 'FL', display: 'Florida'},
            { id: 'GA', display: 'Georgia'},
            { id: 'HI', display: 'Hawaii'},
            { id: 'ID', display: 'Idaho'},
            { id: 'IA', display: 'Iowa'},
            { id: 'IL', display: 'Illinois'},
            { id: 'IN', display: 'Indiana'},
            { id: 'KS', display: 'Kansas'},
            { id: 'KY', display: 'Kentucky'},
            { id: 'LA', display: 'Louisiana'},
            { id: 'ME', display: 'Maine'},
            { id: 'MD', display: 'Maryland'},
            { id: 'MA', display: 'Massachusetts'},
            { id: 'MI', display: 'Michigan'},
            { id: 'MN', display: 'Minnesota'},
            { id: 'MS', display: 'Mississippi'},
            { id: 'MO', display: 'Missouri'},
            { id: 'MT', display: 'Montana'},
            { id: 'NE', display: 'Nebraska'},
            { id: 'NH', display: 'New Hampshire'},
            { id: 'NJ', display: 'New Jersey'},
            { id: 'NM', display: 'New Mexico'},
            { id: 'NV', display: 'Nevada'},
            { id: 'NY', display: 'New York'},
            { id: 'NC', display: 'North Carolina'},
            { id: 'ND', display: 'North Dakota'},
            { id: 'OH', display: 'Ohio'},
            { id: 'OK', display: 'Oklahoma'},
            { id: 'OR', display: 'Oregon'},
            { id: 'PA', display: 'Pennsylvania'},
            { id: 'RI', display: 'Rhode Island'},
            { id: 'SC', display: 'South Carolina'},
            { id: 'SD', display: 'South Dakota'},
            { id: 'TN', display: 'Tennessee'},
            { id: 'TX', display: 'Texas'},
            { id: 'UT', display: 'Utah'},
            { id: 'VT', display: 'Vermont'},
            { id: 'VA', display: 'Virginia'},
            { id: 'WA', display: 'Washington'},
            { id: 'WV', display: 'West Virginia'},
            { id: 'WI', display: 'Wisconsin'},
            { id: 'WY', display: 'Wyoming'}
        ];

        const segmentOps = [
            {id: "commerical", display: "Commerical"},
            {id: "home_automation", display: "Home Automation"},
            {id: "industrial", display: "Industrial"},
            {id: "residential", display: "Residential"},
        ];

        const servicesOpts = [
            {id: "audio_visual", display: "Audio/Visual"},
            {id: "high_voltage_install", display: "High Voltage Install"},
            {id: "low_voltage_install", display: "Low Voltage Install"},
            {id: "smart_home_install", display: "Smart Home Install"},
            {id: "wholehome_automation", display: "Wholehome Automation"},
        ];

        const refferalOpts = [
            {id: "customer", display: "Customer"},
            {id: "distributor", display: "Distributer"},
            {id: "email", display: "Email"},
            {id: "facebook", display: "Facebook"},
            {id: "instagram", display: "Instagram"},
            {id: "lighting_showroom", display: "Lighting Showroom"},
            {id: "print_ad", display: "Print Ad"},
            {id: "sales_rep", display: "Sales Rep"},
            {id: "tradeshow", display: "Tradeshow"},
            {id: "tv", display: "TV"},
            {id: "word_of_mouth", display: "Word of Mouth"},
        ];

        const businessOpts = [
            {id: "", display: "Business Type*"},
            {id: "av_solution_provider", display: "AV Solution Provider"},
            {id: "electrical_wholesale", display: "Electrical Wholesale"},
            {id: "lighting_showrooml", display: "Lighting Showroom"},
            {id: "lighting_wholesale", display: "Lighting Wholesale"},
        ];

        const phoneRegExp = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

        const ProfileSchema = Yup.object().shape({
            email: Yup.string().email('This value should be a valid email.').required('This value is required.'),
            first_name: Yup.string().required('This value is required.'),
            last_name: Yup.string().required('This value is required.'),
            name: Yup.string().required('This value is required.'),
            dba: Yup.string().required('This value is required.'),
            primary_jobtitle: Yup.string().required('This value is required.'),
            phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid').required('This value is required.'),
            //country: Yup.string().required('This value is required.'),
            //address: Yup.string().required('This value is required.'),
            //city: Yup.string().required('This value is required.'),
           // state: Yup.string().required('This value is required.'),
           // postal: Yup.string().required('This value is required.').matches(/^[a-zA-Z0-9]*$/, 'This value should be alphanumeric characters only'),
            domain: Yup.string().required('This value is required.').url('This value should be a valid url.'),
            //years_in_business: Yup.string().required('This value is required.'),
            established: Yup.string().required('This value is required.'),
            coverage_segments: Yup.string().required('This value is required.'),
            services_offered: Yup.string().required('This value is required.'),
            number_of_employees: Yup.string().required('This value is required.'),
            business_type: Yup.string().required('This value is required'),
            sales_name: Yup.string().required('This value is required.'),
            sales_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid').required('This value is required.'),
            sales_email: Yup.string().email('This value should be a valid email.').required('This value is required.'),
            accounts_name: Yup.string().required('This value is required.'),
            accounts_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid').required('This value is required.'),
            accounts_email: Yup.string().email('This value should be a valid email.').required('This value is required.'),
            logistics_name: Yup.string().required('This value is required.'),
            logistics_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid').required('This value is required.'),
            logistics_email: Yup.string().email('This value should be a valid email.').required('This value is required.'),
            bank_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid'),
            bank_email: Yup.string().email('This value should be a valid email.'),
            first_creditref_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid'),
            first_creditref_email: Yup.string().email('This value should be a valid email.'),
            second_creditref_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid'),
            second_creditref_email: Yup.string().email('This value should be a valid email.'),
        });

        let hearAboutNoon = "";
        if(this.state.cData.additional_information_hearAboutNoon != "" && this.state.cData.additional_information_hearAboutNoon != null && this.state.cData.additional_information_hearAboutNoon != 'undefined') {
            hearAboutNoon = this.state.cData.additional_information_hearAboutNoon.split(',');
        }

        //console.log('update', this.state.updateFlag);
        //console.log('edit', this.state.editingProfile);
       // console.log('error', this.state.isError);
        //console.log('compD', this.state.companyD);
        //console.log('c data', this.state.cData);

        let subsidiaryName = "";
        if(this.state.cData.subsidiary_name != 'undefined') {
            subsidiaryName = this.state.cData.subsidiary_name;
        };

        let mailingAddress = "";
        if(this.state.cData.mailing_address != 'undefined') {
            mailingAddress = this.state.cData.mailing_address;
        };

        let mailingCity = "";
        if(this.state.cData.mailing_city != 'undefined') {
            mailingCity = this.state.cData.mailing_city;
        };

        let mailingPostal = "";
        if(this.state.cData.mailing_postal != 'undefined') {
            mailingPostal = this.state.cData.mailing_postal;
        };

        let Duns = "";
        if(this.state.cData.duns != 'undefined') {
            Duns = this.state.cData.duns;
        };

        let bankName = "";
        if(this.state.cData.bank_name != 'undefined') {
            bankName = this.state.cData.bank_name;
        };

        let bankAddress = "";
        if(this.state.cData.bank_address != 'undefined') {
            bankAddress = this.state.cData.bank_address;
        };

        let bankRepresentative = "";
        if(this.state.cData.bank_representative != 'undefined') {
            bankRepresentative = this.state.cData.bank_representative;
        };

        let bankPhone = "";
        if(this.state.cData.bank_phone != 'undefined') {
            bankPhone = this.state.cData.bank_phone;
        };

        let bankEmail = "";
        if(this.state.cData.bank_email != 'undefined') {
            bankEmail = this.state.cData.bank_email;
        };

        let firstCname = "";
        if(this.state.cData.first_creditref_name != 'undefined') {
            firstCname = this.state.cData.first_creditref_name;
        };

        let firstCaddress = "";
        if(this.state.cData.first_creditref_address != 'undefined') {
            firstCaddress = this.state.cData.first_creditref_address;
        };

        let firstCrepresentative = "";
        if(this.state.cData.first_creditref_representative != 'undefined') {
            firstCrepresentative = this.state.cData.first_creditref_representative;
        };

        let firstCphone = "";
        if(this.state.cData.first_creditref_phone != 'undefined') {
            firstCphone = this.state.cData.first_creditref_phone;
        };

        let firstCemail = "";
        if(this.state.cData.first_creditref_email != 'undefined') {
            firstCemail = this.state.cData.first_creditref_email;
        };

        let secondCname = "";
        if(this.state.cData.second_creditref_name != 'undefined') {
            secondCname = this.state.cData.second_creditref_name;
        };

        let secondCaddress = "";
        if(this.state.cData.second_creditref_address != 'undefined') {
            secondCaddress = this.state.cData.second_creditref_address;
        };

        let secondCrepresentative = "";
        if(this.state.cData.second_creditref_representative != 'undefined') {
            secondCrepresentative = this.state.cData.second_creditref_representative;
        };

        let secondCphone = "";
        if(this.state.cData.second_creditref_phone != 'undefined') {
            secondCphone = this.state.cData.second_creditref_phone;
        };

        let secondCemail = "";
        if(this.state.cData.second_creditref_email != 'undefined') {
            secondCemail = this.state.cData.second_creditref_email;
        };

        let numberOfStores = "";
        if(this.state.companyD.number_of_stores != 'null') {
            numberOfStores = this.state.companyD.number_of_stores;
        }


        return(
            <div>
                {this.state.userLoaded === true && this.state.compLoaded === true && this.state.cDataLoaded === true ?
                    <div className='profile-data'>
                        <div className='short-desc'>
                            <h5>{this.state.companyD.name}</h5>
                            <p>{this.state.companyD.address}, {this.state.companyD.city}, {this.state.companyD.state}</p>
                            <a className='user--domain--link'
                               href={this.state.companyD.domain}>{this.state.companyD.domain}</a>
                            <br/>
                            <button className='edit-p-button' onClick={this.editProfile}>Edit Profile</button>
                            <section>
                                <input ref="onUploadUserFile" onChange={this.onUploadUserFile} style={{display: 'none'}} type="file" />
                            </section>
                        </div>
                        <div className='profile-details'>
                            <h3>Primary Contact Information</h3>
                            {this.state.editingProfile === true ?
                                <Formik

                                    initialValues={{
                                        email: this.state.userD.email,
                                        first_name: this.state.cData.first_name,
                                        last_name: this.state.cData.last_name,
                                        name: this.state.companyD.name,
                                        dba: this.state.companyD.dba,
                                        primary_jobtitle: this.state.companyD.primary_jobtitle,
                                        phone: this.state.companyD.phone,
                                        address: this.state.companyD.address,
                                        country: this.state.companyD.country,
                                        city: this.state.companyD.city,
                                        state: this.state.companyD.state,
                                        postal: this.state.companyD.postal,
                                        domain: this.state.companyD.domain,
                                        reseller_certification: this.state.companyD.reseller_certification,
                                        coverage_segments: this.state.companyD.coverage_segments.split(','),
                                        services_offered: this.state.companyD.services_offered.split(','),
                                        number_of_employees: this.state.companyD.number_of_employees,

                                        dealer_finder: this.state.companyD.dealer_finder,
                                        provide_staff_training: false,
                                        experience_with_noon: this.state.companyD.experience_with_noon,
                                        additional_information_hearAboutNoon: hearAboutNoon,
                                        business_type: this.state.companyD.business_type,
                                        number_of_stores: numberOfStores,

                                        onboarding: this.state.cData.onboarding,
                                        subsidiary_name: subsidiaryName,
                                        mailing_address: mailingAddress,
                                        mailing_city: mailingCity,
                                        mailing_state: this.state.cData.mailing_state,
                                        mailing_postal: mailingPostal,
                                        mailing_country: this.state.cData.mailing_country,
                                        established: this.state.cData.established,
                                        duns: Duns,
                                        sales_name: this.state.cData.sales_name,
                                        sales_phone: this.state.cData.sales_phone,
                                        sales_email: this.state.cData.sales_email,
                                        accounts_name: this.state.cData.accounts_name,
                                        accounts_phone: this.state.cData.accounts_phone,
                                        accounts_email: this.state.cData.accounts_email,
                                        logistics_name: this.state.cData.logistics_name,
                                        logistics_phone: this.state.cData.logistics_phone,
                                        logistics_email: this.state.cData.logistics_email,
                                        bank_name: bankName,
                                        bank_address: bankAddress,
                                        bank_representative: bankRepresentative,
                                        bank_phone: bankPhone,
                                        bank_email: bankEmail,
                                        first_creditref_name: firstCname,
                                        first_creditref_address: firstCaddress,
                                        first_creditref_representative: firstCrepresentative,
                                        first_creditref_phone: firstCphone,
                                        first_creditref_email: firstCemail,
                                        second_creditref_name: secondCaddress,
                                        second_creditref_address: secondCaddress,
                                        second_creditref_representative: secondCrepresentative,
                                        second_creditref_phone: secondCphone,
                                        second_creditref_email: secondCemail,

                                    }}
                                    enableReinitialize={true}
                                    validationSchema={ProfileSchema}
                                    onSubmit={ async (values, actions) => {
                                        let yearsInB = parseInt(values.years_in_business, 10);
                                        let numberOfE = parseInt(values.number_of_employees, 10);

                                        let hearedAbout = "";
                                        if (values.additional_information_hearAboutNoon != "" && values.additional_information_hearAboutNoon != []) {
                                            hearedAbout = values.additional_information_hearAboutNoon.join(",")
                                        }
                                        console.log('about N', hearedAbout);
                                        let cSegments = "";
                                        if (values.coverage_segments != "" && values.coverage_segments != []) {
                                            cSegments = values.coverage_segments.join(",")
                                        }
                                        //console.log('s segs', cSegments);

                                        let servicesO = "";
                                        if (values.services_offered != "" && values.services_offered != []) {
                                            servicesO = values.services_offered.join(",")
                                        }
                                        //console.log('services', servicesO);

                                        let expWnoon = false;
                                        if(values.experience_with_noon === true) {
                                            expWnoon = true
                                        }

                                        let dealerF = false;
                                        if(values.dealer_finder === true) {
                                            dealerF = true
                                        }

                                        let staffTr = false;
                                        if(values.provide_staff_training === true) {
                                            staffTr = true
                                        }

                                        let data =  await this.handleVerifyAddress(this.state.address, this.state.city, this.state.state, this.state.postal, this.state.country,);

                                        return Promise.all([
                                            request.post('/api/user')
                                                .send({
                                                    email: values.email,
                                                    first_name: values.first_name,
                                                    last_name: values.last_name,
                                                    additional_information_hearAboutNoon: hearedAbout,
                                                    subsidiary_name: values.subsidiary_name,
                                                    mailing_address: values.mailing_address,
                                                    mailing_city: values.mailing_city,
                                                    mailing_state: values.mailing_state,
                                                    mailing_postal: values.mailing_postal,
                                                    mailing_country: values.mailing_country,
                                                    established: values.established,
                                                    duns: values.duns,
                                                    sales_name: values.sales_name,
                                                    sales_phone: values.sales_phone,
                                                    sales_email: values.sales_email,
                                                    accounts_name: values.accounts_name,
                                                    accounts_phone: values.accounts_phone,
                                                    accounts_email: values.accounts_email,
                                                    logistics_name: values.logistics_name,
                                                    logistics_phone: values.logistics_phone,
                                                    logistics_email: values.logistics_email,
                                                    bank_name: values.bank_name,
                                                    bank_address: values.bank_address,
                                                    bank_representative: values.bank_representative,
                                                    bank_phone: values.bank_phone,
                                                    bank_email: values.bank_email,
                                                    first_creditref_name: values.first_creditref_name,
                                                    first_creditref_address: values.first_creditref_address,
                                                    first_creditref_representative: values.first_creditref_representative,
                                                    first_creditref_phone: values.first_creditref_phone,
                                                    first_creditref_email: values.first_creditref_email,
                                                    second_creditref_name: values.second_creditref_name,
                                                    second_creditref_address: values.second_creditref_address,
                                                    second_creditref_representative: values.second_creditref_representative,
                                                    second_creditref_phone: values.second_creditref_phone,
                                                    second_creditref_email: values.second_creditref_email,
                                                }),
                                            request.post('/api/company')
                                                .send({
                                                    name: values.name,
                                                    dba: values.dba,
                                                    primary_jobtitle: values.primary_jobtitle,
                                                    phone: values.phone,
                                                    country: this.state.country,
                                                    address: this.state.address,
                                                    city: this.state.city,
                                                    state: this.state.state,
                                                    postal: this.state.postal,
                                                    domain: values.domain,
                                                    reseller_certification: values.reseller_certification,
                                                    years_in_business: null,
                                                    coverage_segments: cSegments,
                                                    services_offered: servicesO,
                                                    number_of_employees: numberOfE,
                                                    dealer_finder: dealerF,
                                                    experience_with_noon: expWnoon,
                                                    provide_staff_training: staffTr,
                                                    business_type: values.business_type,
                                                    number_of_stores: values.number_of_stores,
                                                    address_status: this.state.address_status,
                                                    latitude: this.state.lat,
                                                    longitude: this.state.long,
                                                    geospatial: this.state.geo,

                                                    coverage_range: null,

                                                })
                                        ])
                                            .then(data => {
                                                //console.log('finished user call');
                                                //console.log(data);
                                            })
                                            .then(resp => {
                                                this.setState({
                                                    updateFlag: true,
                                                    geo: null,
                                                    lat: null,
                                                    long: null,
                                                    address_status:'',
                                                })
                                            })
                                            .catch(err => {
                                                console.error(err);
                                                this.setState({isError: true});
                                            });

                                    }}>
                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          setFieldValue,
                                          handleReset,
                                          dirty,
                                          isValid,
                                          isValidating,

                                      }) => (
                                        <Form className='my-f-form' onSubmit={e => {
                                            handleSubmit(e);
                                            if(isDisabled === true) {
                                                this.handleSubmitErr(e)
                                            }
                                        }}>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='email'
                                                className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.email}/>
                                            {errors.email && touched.email ?
                                                (<div className='f-field-errors'>{errors.email} </div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='first_name'
                                                            component='input'
                                                            className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='First Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.first_name}
                                                        />
                                                        {errors.first_name && touched.first_name ? (
                                                            <div
                                                                className='f-field-errors'>{errors.first_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='last_name'
                                                            component='input'
                                                            className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='Last Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.last_name}
                                                        />
                                                        {errors.last_name && touched.last_name ?
                                                            (<div
                                                                className='f-field-errors'>{errors.last_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <h3 className='profile-data-section'>Business Information</h3>

                                            <label className='form-f-label'>Company Name*</label>
                                            <Field
                                                name='name'
                                                component='input'
                                                className={errors.name && touched.name ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Company Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.name}
                                            />
                                            {errors.name && touched.name ?
                                                (<div className='f-field-errors'>{errors.name}</div>) : null
                                            }

                                            <label className='form-f-label'>Doing Business As (DBA)*</label>
                                            <Field
                                                name='dba'
                                                component='input'
                                                className={errors.dba && touched.dba ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Doing Business As*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.dba}
                                            />
                                            {errors.dba && touched.dba ?
                                                (<div className='f-field-errors'>{errors.dba}</div>) : null
                                            }

                                            <label className='form-f-label'>If Subsidiary, Name of Parent Company</label>
                                            <Field
                                                name='subsidiary_name'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Subsidiary Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.subsidiary_name}
                                            />

                                            <label className='form-f-label'>Job Title*</label>
                                            <Field
                                                name='primary_jobtitle'
                                                component='input'
                                                className={errors.primary_jobtitle && touched.primary_jobtitle ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Job Title*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.primary_jobtitle}
                                            />
                                            {errors.primary_jobtitle && touched.primary_jobtitle ?
                                                (<div className='f-field-errors'>{errors.primary_jobtitle}</div>) : null
                                            }

                                            <label className='form-f-label'>Primary Phone*</label>
                                            <Field
                                                name='phone'
                                                component='input'
                                                className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.phone}
                                            />
                                            {errors.phone && touched.phone ?
                                                (<div className='f-field-errors'>{errors.phone}</div>) : null
                                            }

                                            <h4 className='profile-data-sub-section'>Company Billing Address</h4>

                                            <label className='form-f-label'>Country*</label>
                                            <select
                                                id='addressAutocomplete.country'
                                                name='country'
                                                className='single-choice-selector'
                                                value={this.state.country}
                                                onChange={e => this.handleCountryChange(e)}
                                                onBlur={this.handleAdrBlur('country')}
                                            >
                                                {countryOpts.map(option => (
                                                    <option key={`country-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </select>
                                            {shouldShowError('country') ?
                                                (<div className='f-field-errors'>This value is required.</div>) : null
                                            }

                                            <label className='form-f-label'>Address*</label>
                                            <input
                                                name='address'
                                                className={shouldShowError('address') ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                id='addressAutocomplete.street'
                                                placeholder='Address*'
                                                value={this.state.address}
                                                onChange={e => this.handleAdrChange(e)}
                                                onBlur={this.handleAdrBlur('address')}
                                            />
                                            {shouldShowError('address') ?
                                                (<div className='f-field-errors'>This value is required.</div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>City*</label>
                                                    <input
                                                        name='city'
                                                        className={shouldShowError('city') ? 'form-f-field with-error' : 'form-f-field'}
                                                        type='text'
                                                        id='addressAutocomplete.city'
                                                        placeholder='City*'
                                                        value={this.state.city}
                                                        onChange={e => this.handleCityChange(e)}
                                                        onBlur={this.handleAdrBlur('city')}
                                                    />
                                                    {shouldShowError('city') ?
                                                        (<div className='f-field-errors'>This value is required.</div>) : null
                                                    }
                                                </div>

                                                {this.state.country === 'CA' ?
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <select
                                                            name='state'
                                                            id='addressAutocomplete.state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={this.state.state}
                                                            onChange={e => this.handleStateChange(e)}
                                                            onBlur={this.handleAdrBlur('state')}
                                                        >
                                                            {caStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {shouldShowError('state') ?
                                                            (<div className='f-field-errors'>This value is required.</div>) : null
                                                        }
                                                    </div>:
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <select
                                                            name='state'
                                                            id='addressAutocomplete.state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={this.state.state}
                                                            onChange={e => this.handleStateChange(e)}
                                                            onBlur={this.handleAdrBlur('state')}
                                                        >
                                                            {usStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {shouldShowError('state') ?
                                                            (<div className='f-field-errors'>This value is required.</div>) : null
                                                        }
                                                    </div>
                                                }

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Postal Code*</label>
                                                    <input
                                                        name='postal'
                                                        id='addressAutocomplete.postal'
                                                        className={shouldShowError('postal') ? 'form-f-field with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Postal Code*'
                                                        value={this.state.postal}
                                                        onChange={e => this.handlePostalChange(e)}
                                                        onBlur={this.handleAdrBlur('postal')}
                                                    />
                                                    {shouldShowError('postal') ?
                                                        (<div className='f-field-errors'>This value is required.</div>) : null
                                                    }
                                                </div>
                                            </div>

                                            <h4 className='profile-data-sub-section'>Company Mailing Address (if different from Billing Address above)</h4>

                                            <label className='form-f-label'>Country</label>
                                            <select
                                                name='mailing_country'
                                                className='single-choice-selector'
                                                value={values.mailing_country}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            >
                                                {countryOpts.map(option => (
                                                    <option key={`mailing_country-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </select>

                                            <label className='form-f-label'>Address</label>
                                            <input
                                                name='mailing_address'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Address'
                                                value={values.mailing_address}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>City</label>
                                                    <input
                                                        name='mailing_city'
                                                        className='form-f-field'
                                                        type='text'
                                                        placeholder='City'
                                                        value={values.mailing_city}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />

                                                </div>

                                                {this.state.country === 'CA' ?
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State</label>
                                                        <select
                                                            name='mailing_state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={values.mailing_state}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        >
                                                            {caStateOpts.map(option => (
                                                                <option key={`mailing_state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>:
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State</label>
                                                        <select
                                                            name='mailing_state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={values.mailing_state}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        >
                                                            {usStateOpts.map(option => (
                                                                <option key={`mailing_state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                }

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Postal Code</label>
                                                    <input
                                                        name='mailing_postal'
                                                        className='form-f-field'
                                                        type='text'
                                                        placeholder='Postal Code'
                                                        value={values.mailing_postal}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Website*</label>
                                            <Field
                                                name='domain'
                                                component='input'
                                                className={errors.domain && touched.domain ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Website*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.domain}
                                            />
                                            {errors.domain && touched.domain ?
                                                (<div className='f-field-errors'>{errors.domain}</div>) : null
                                            }

                                            <label className='form-f-label'>Year Established*</label>
                                            <Field
                                                name='established'
                                                component='input'
                                                className={errors.established && touched.established ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Year Established*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.established}
                                            />
                                            {errors.established && touched.established ?
                                                (<div className='f-field-errors'>{errors.established}</div>) : null
                                            }

                                            <label className='form-f-label'>D&B/DUNS Number</label>
                                            <Field
                                                name='duns'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='D&B/DUNS Number'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.duns}
                                            />

                                            <label className='form-f-label'>Reseller Certification Number</label>
                                            <input className='form-f-field'
                                                   type='text'
                                                   name='reseller_certification'
                                                   placeholder='Reseller Certification Number'
                                                   onChange={handleChange}
                                                   onBlur={handleBlur}
                                                   value={values.reseller_certification}
                                            />

                                            <p className='disclaimer--copy'>Specify your reseller tax number and state
                                                above and upload a copy of your reseller certificate below.
                                                If you sell in multiple states, please upload them as a zip file. If no
                                                reseller certificate is provided, applicable sales tax will be charged
                                                on your purchases.</p>
                                            <br/>
                                            <section>
                                                <a className='edit-p-button' onClick={this.uploadResellerCertificate}>{this.state.uploadingCertificate ? 'Saving...' :  'Upload Certificate'}</a>
                                                <input name="onUploadUserFile" onChange={this.onUploadUserFile} style={{display: 'none'}} type="file" />
                                            </section>
                                            <br/>
                                            {this.state.companyD.reseller_certification_path !== undefined && this.state.companyD.reseller_certification_path !== "null"?
                                                <a className='edit-p-button' href={this.state.companyD.reseller_certification_path} target="_blank">View Certificate</a> : null
                                            }

                                            <label className='form-f-label'>Business Type*</label>
                                            <Field name='business_type' component='select'
                                                   className='single-choice-selector'>
                                                {businessOpts.map(option => (
                                                    <option key={`business_type-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>
                                            {errors.business_type && touched.business_type ?
                                                (<div className='f-field-errors'>{errors.business_type}</div>) : null
                                            }

                                            <label className='form-f-label'>Number of Stores/Branches</label>
                                            <Field
                                                name='number_of_stores'
                                                component='input'
                                                className={errors.number_of_stores && touched.number_of_stores ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Number of Stores/Branches'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.number_of_stores}
                                            />
                                            {errors.number_of_stores && touched.number_of_stores ?
                                                (<div className='f-field-errors'>{errors.number_of_stores}</div>) : null
                                            }


                                            <h3 className='profile-data-section'>Contact Information</h3>

                                            <p className='disclaimer--copy'>Please provide appropriate contact information for the departments listed below.
                                                This will ensure we are communicating with the appropriate members of your business. </p>

                                            <h5 className='profile-data-sub-section'>Sales</h5>

                                            <label className='form-f-label'>Name*</label>
                                            <Field
                                                name='sales_name'
                                                className={errors.sales_name && touched.sales_name ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.sales_name}/>
                                            {errors.sales_name && touched.sales_name ?
                                                (<div className='f-field-errors'>{errors.sales_name} </div>) : null
                                            }

                                            <label className='form-f-label'>Phone*</label>
                                            <Field
                                                name='sales_phone'
                                                className={errors.sales_phone && touched.sales_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Phone*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.sales_phone}/>
                                            {errors.sales_phone && touched.sales_phone ?
                                                (<div className='f-field-errors'>{errors.sales_phone} </div>) : null
                                            }

                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='sales_email'
                                                className={errors.sales_email && touched.sales_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.sales_email}/>
                                            {errors.sales_email && touched.sales_email ?
                                                (<div className='f-field-errors'>{errors.sales_email} </div>) : null
                                            }

                                            <h5 className='profile-data-sub-section'>Accounts Payable</h5>

                                            <label className='form-f-label'>Name*</label>
                                            <Field
                                                name='accounts_name'
                                                className={errors.accounts_name && touched.accounts_name ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.accounts_name}/>
                                            {errors.accounts_name && touched.accounts_name ?
                                                (<div className='f-field-errors'>{errors.accounts_name} </div>) : null
                                            }

                                            <label className='form-f-label'>Phone*</label>
                                            <Field
                                                name='accounts_phone'
                                                className={errors.accounts_phone && touched.accounts_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Phone*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.accounts_phone}/>
                                            {errors.accounts_phone && touched.accounts_phone ?
                                                (<div className='f-field-errors'>{errors.accounts_phone} </div>) : null
                                            }

                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='accounts_email'
                                                className={errors.accounts_email && touched.accounts_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.accounts_email}/>
                                            {errors.accounts_email && touched.accounts_email ?
                                                (<div className='f-field-errors'>{errors.accounts_email} </div>) : null
                                            }

                                            <h5 className='profile-data-sub-section'>Shipping & Logistics</h5>

                                            <label className='form-f-label'>Name*</label>
                                            <Field
                                                name='logistics_name'
                                                className={errors.logistics_name && touched.logistics_name ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.logistics_name}/>
                                            {errors.logistics_name && touched.logistics_name ?
                                                (<div className='f-field-errors'>{errors.logistics_name} </div>) : null
                                            }

                                            <label className='form-f-label'>Phone*</label>
                                            <Field
                                                name='logistics_phone'
                                                className={errors.logistics_phone && touched.logistics_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Phone*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.logistics_phone}/>
                                            {errors.logistics_phone && touched.logistics_phone ?
                                                (<div className='f-field-errors'>{errors.logistics_phone} </div>) : null
                                            }

                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='logistics_email'
                                                className={errors.logistics_email && touched.logistics_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.logistics_email}/>
                                            {errors.logistics_email && touched.logistics_email ?
                                                (<div className='f-field-errors'>{errors.logistics_email} </div>) : null
                                            }

                                            <h3 className='profile-data-section'>Bank & Credit References</h3>

                                            <p className='disclaimer--copy'>If you would like credit terms to be extended to your business please provide your bank and credit reference(s) for credit review by NOON.
                                                If no credit needs to be extended (i.e., paying by credit card) please leave blank.</p>

                                            <h5 className='profile-data-sub-section'>Bank Reference</h5>

                                            <label className='form-f-label'>Bank Name</label>
                                            <Field
                                                name='bank_name'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Name'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.bank_name}/>


                                            <label className='form-f-label'>Bank Address</label>
                                            <Field
                                                name='bank_address'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Address'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.bank_address}/>

                                            <label className='form-f-label'>Bank Contact Representative</label>
                                            <Field
                                                name='bank_representative'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Contact Representative'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.bank_representative}/>
                                            <label className='form-f-label'>Bank Contact Phone Number</label>
                                            <Field
                                                name='bank_phone'
                                                className={errors.bank_phone && touched.bank_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.bank_phone}/>
                                            {errors.bank_phone && touched.bank_phone ?
                                                (<div className='f-field-errors'>{errors.bank_phone} </div>) : null
                                            }

                                            <label className='form-f-label'>Bank Contact Email</label>
                                            <Field
                                                name='bank_email'
                                                className={errors.bank_email && touched.bank_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Bank Contact Email'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.bank_email}/>
                                            {errors.bank_email && touched.bank_email ?
                                                (<div className='f-field-errors'>{errors.bank_email} </div>) : null
                                            }

                                            <h5 className='profile-data-sub-section'>Credit Reference #1</h5>

                                            <label className='form-f-label'>Company Name</label>
                                            <Field
                                                name='first_creditref_name'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Name'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.first_creditref_name}/>


                                            <label className='form-f-label'>Company Address</label>
                                            <Field
                                                name='first_creditref_address'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Address'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.first_creditref_address}/>

                                            <label className='form-f-label'>Company Contact Representative</label>

                                            <Field
                                                name='first_creditref_representative'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Representative'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.first_creditref_representative}/>

                                            <label className='form-f-label'>Company Contact Phone Number</label>
                                            <Field
                                                name='first_creditref_phone'
                                                className={errors.first_creditref_phone && touched.first_creditref_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.first_creditref_phone}/>
                                            {errors.first_creditref_phone && touched.first_creditref_phone ?
                                                (<div className='f-field-errors'>{errors.first_creditref_phone} </div>) : null
                                            }

                                            <label className='form-f-label'>Company Contact Email</label>
                                            <Field
                                                name='first_creditref_email'
                                                className={errors.first_creditref_email && touched.first_creditref_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Email'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.first_creditref_email}/>
                                            {errors.first_creditref_email && touched.first_creditref_email ?
                                                (<div className='f-field-errors'>{errors.first_creditref_email} </div>) : null
                                            }


                                            <h5 className='profile-data-sub-section'>Credit Reference #2</h5>

                                            <label className='form-f-label'>Company Name</label>
                                            <Field
                                                name='second_creditref_name'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Name'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.second_creditref_name}/>


                                            <label className='form-f-label'>Company Address</label>
                                            <Field
                                                name='second_creditref_address'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Address'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.second_creditref_address}/>

                                            <label className='form-f-label'>Company Contact Representative</label>

                                            <Field
                                                name='second_creditref_representative'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Representative'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.second_creditref_representative}/>

                                            <label className='form-f-label'>Company Contact Phone Number</label>
                                            <Field
                                                name='second_creditref_phone'
                                                className={errors.second_creditref_phone && touched.second_creditref_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.second_creditref_phone}/>
                                            {errors.second_creditref_phone && touched.second_creditref_phone ?
                                                (<div className='f-field-errors'>{errors.second_creditref_phone} </div>) : null
                                            }

                                            <label className='form-f-label'>Company Contact Email</label>
                                            <Field
                                                name='second_creditref_email'
                                                className={errors.second_creditref_email && touched.second_creditref_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Email'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.second_creditref_email}/>
                                            {errors.second_creditref_email && touched.second_creditref_email ?
                                                (<div className='f-field-errors'>{errors.second_creditref_email} </div>) : null
                                            }


                                            <h3 className='profile-data-section'>Coverage Information</h3>
                                            <label className='form-f-label'>Coverage Segments*</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='coverage_segments'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {segmentOps.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            name='coverage_segments'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.coverage_segments.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.coverage_segments.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.coverage_segments && touched.coverage_segments ?
                                                        (<div
                                                            className='f-field-errors'>{errors.coverage_segments}</div> ) : null
                                                    }
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Services Offered*</label>

                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='services_offered'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {servicesOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            name='services_offered'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.services_offered.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.services_offered.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.services_offered && touched.services_offered ?
                                                        (<div
                                                            className='f-field-errors'>{errors.services_offered}</div>) : null
                                                    }
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Number of Employees*</label>
                                            <Field
                                                name='number_of_employees'
                                                component='input'
                                                className={errors.number_of_employees && touched.number_of_employees ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Number of Employees*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.number_of_employees}
                                            />
                                            {errors.number_of_employees && touched.number_of_employees ?
                                                (<div
                                                    className='f-field-errors'>{errors.number_of_employees}</div>) : null
                                            }

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='dealer_finder'
                                                    checked={values.dealer_finder}
                                                    onChange={handleChange}
                                                />
                                                <p className='toggle-in-label'>Add to NOON Finder?</p>
                                            </div>
                                            <br/>
                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='provide_staff_training'
                                                    checked={values.provide_staff_training}
                                                    onChange={handleChange}
                                                />
                                                <p className='toggle-in-label'>Can NOON provide training of staff?</p>
                                            </div>

                                            <h3 className='profile-data-section'>Additional Information</h3>

                                            <label className='form-f-label'> How you heard about NOON?</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='additional_information_hearAboutNoon'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {refferalOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            name='additional_information_hearAboutNoon'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.additional_information_hearAboutNoon.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.additional_information_hearAboutNoon.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='experience_with_noon'
                                                    checked={values.experience_with_noon}
                                                    onChange={handleChange}
                                                />
                                                <p className='toggle-in-label'>Do you have Experience installing
                                                    NOON?</p>
                                            </div>

                                            <div className='error-box-cont'>
                                                {this.state.isError === true ?
                                                    <p className='submission-error-text'>Ooops something went wrong!
                                                        Please try again later</p> :
                                                    null
                                                }
                                            </div>

                                            {isDisabled === true ?
                                                <button type='submit' className='form-f-button' onClick={e => this.handleSubmitErr(e)}> Save Profile</button> :
                                                <button type='submit' className='form-f-button'> Save Profile</button>
                                            }

                                            {dirty ?
                                                <a className='form-cancel-button'
                                                        onClick={handleReset}>
                                                    Reset Form
                                                </a> :
                                                <a className='form-cancel-button'
                                                        onClick={this.editProfile}>
                                                    Cancel
                                                </a>
                                            }
                                        </Form>
                                    )}
                                </Formik> :
                                <Formik
                                    initialValues={{
                                        email: this.state.userD.email,
                                        first_name: this.state.cData.first_name,
                                        last_name: this.state.cData.last_name,
                                        name: this.state.companyD.name,
                                        dba: this.state.companyD.dba,
                                        primary_jobtitle: this.state.companyD.primary_jobtitle,
                                        phone: this.state.companyD.phone,
                                        address: this.state.companyD.address,
                                        country: this.state.companyD.country,
                                        city: this.state.companyD.city,
                                        state: this.state.companyD.state,
                                        postal: this.state.companyD.postal,
                                        domain: this.state.companyD.domain,
                                        reseller_certification: this.state.companyD.reseller_certification,

                                        coverage_segments: this.state.companyD.coverage_segments.split(','),
                                        services_offered: this.state.companyD.services_offered.split(','),
                                        number_of_employees: this.state.companyD.number_of_employees,

                                        dealer_finder: this.state.companyD.dealer_finder,
                                        provide_staff_training: false,
                                        experience_with_noon: this.state.companyD.experience_with_noon,
                                        additional_information_hearAboutNoon: hearAboutNoon,
                                        business_type: this.state.companyD.business_type,
                                        number_of_stores: numberOfStores,

                                        subsidiary_name: subsidiaryName,
                                        mailing_address: mailingAddress,
                                        mailing_city: mailingCity,
                                        mailing_state: this.state.cData.mailing_state,
                                        mailing_postal: mailingPostal,
                                        mailing_country: this.state.cData.mailing_country,
                                        established: this.state.cData.established,
                                        duns: Duns,
                                        sales_name: this.state.cData.sales_name,
                                        sales_phone: this.state.cData.sales_phone,
                                        sales_email: this.state.cData.sales_email,
                                        accounts_name: this.state.cData.accounts_name,
                                        accounts_phone: this.state.cData.accounts_phone,
                                        accounts_email: this.state.cData.accounts_email,
                                        logistics_name: this.state.cData.logistics_name,
                                        logistics_phone: this.state.cData.logistics_phone,
                                        logistics_email: this.state.cData.logistics_email,
                                        bank_name: bankName,
                                        bank_address: bankAddress,
                                        bank_representative: bankRepresentative,
                                        bank_phone: bankPhone,
                                        bank_email: bankEmail,
                                        first_creditref_name: firstCname,
                                        first_creditref_address: firstCaddress,
                                        first_creditref_representative: firstCrepresentative,
                                        first_creditref_phone: firstCphone,
                                        first_creditref_email: firstCemail,
                                        second_creditref_name: secondCaddress,
                                        second_creditref_address: secondCaddress,
                                        second_creditref_representative: secondCrepresentative,
                                        second_creditref_phone: secondCphone,
                                        second_creditref_email: secondCemail,
                                    }}
                                    enableReinitialize={false}
                                    validationSchema={ProfileSchema}
                                    onSubmit={(values, actions) => {
                                        let yearsInB = parseInt(values.years_in_business, 10);
                                        let numberOfE = parseInt(values.number_of_employees, 10);

                                        let hearedAbout = "";
                                        if (values.additional_information_hearAboutNoon != "" && values.additional_information_hearAboutNoon != []) {
                                            hearedAbout = values.additional_information_hearAboutNoon.join(",")
                                        }
                                        console.log('about N', hearedAbout);
                                        let cSegments = "";
                                        if (values.coverage_segments != "" && values.coverage_segments != []) {
                                            cSegments = values.coverage_segments.join(",")
                                        }
                                        console.log('s segs', cSegments);

                                        let servicesO = "";
                                        if (values.services_offered != "" && values.services_offered != []) {
                                            servicesO = values.services_offered.join(",")
                                        }
                                        console.log('services', servicesO);

                                        let staffTraining = "";
                                        if(values.provide_staff_training === false) {
                                            staffTraining = "0";
                                        }
                                        if(values.provide_staff_training === true) {
                                            staffTraining = "1";
                                        }


                                        return Promise.all([
                                            request.post('/api/user')
                                                .send({
                                                    email: values.email,
                                                    first_name: values.first_name,
                                                    last_name: values.last_name,
                                                    additional_information_hearAboutNoon: hearedAbout,
                                                }),
                                            request.post('/api/company')
                                                .send({
                                                    name: values.name,
                                                    dba: values.dba,
                                                    primary_jobtitle: values.primary_jobtitle,
                                                    phone: values.phone,
                                                    country: values.country,
                                                    address: values.address,
                                                    city: values.city,
                                                    state: values.state,
                                                    postal: values.postal,
                                                    domain: values.domain,
                                                    reseller_certification: values.reseller_certification,
                                                    years_in_business: yearsInB,
                                                    coverage_segments: cSegments,
                                                    services_offered: servicesO,
                                                    number_of_employees: numberOfE,
                                                    dealer_finder: values.dealer_finder,
                                                    experience_with_noon: values.experience_with_noon,
                                                    provide_staff_training: staffTraining,
                                                    business_type: values.business_type,
                                                    number_of_stores: values.number_of_stores,

                                                    coverage_range: null,

                                                })
                                        ])
                                            .then(data => {
                                                console.log('finished user call');
                                                console.log(data);
                                            })
                                            .then(resp => {
                                                this.setState({updateFlag: true})
                                            })
                                    }}>
                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          setFieldValue,
                                          handleReset,
                                          dirty,

                                      }) => (
                                        <Form className='my-f-form'>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='email'
                                                className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                disabled={true}
                                                value={values.email}/>

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='first_name'
                                                            component='input'
                                                            className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='First Name*'
                                                            disabled={true}
                                                            value={values.first_name}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='last_name'
                                                            component='input'
                                                            className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='Last Name*'
                                                            disabled={true}
                                                            value={values.last_name}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <h3 className='profile-data-section'>Business Information</h3>

                                            <label className='form-f-label'>Company Name*</label>
                                            <Field
                                                name='name'
                                                component='input'
                                                className={errors.name && touched.name ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Company Name*'
                                                disabled={true}
                                                value={values.name}
                                            />

                                            <label className='form-f-label'>Doing Business As (DBA)*</label>
                                            <Field
                                                name='dba'
                                                component='input'
                                                className={errors.dba && touched.dba ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Doing Business As*'
                                                disabled={true}
                                                value={values.dba}
                                            />

                                            <label className='form-f-label'>If Subsidiary, Name of Parent Company</label>
                                            <Field
                                                name='subsidiary_name'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Subsidiary Name*'
                                                disabled={true}
                                                value={values.subsidiary_name}
                                            />

                                            <label className='form-f-label'>Job Title*</label>
                                            <Field
                                                name='primary_jobtitle'
                                                component='input'
                                                className={errors.primary_jobtitle && touched.primary_jobtitle ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Job Title*'
                                                disabled={true}
                                                value={values.primary_jobtitle}
                                            />

                                            <label className='form-f-label'>Primary Phone*</label>
                                            <Field
                                                name='phone'
                                                component='input'
                                                className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='(___)___-____'
                                                disabled={true}
                                                value={values.phone}
                                            />

                                            <h5 className='profile-data-sub-section'>Company Billing Address</h5>

                                            <label className='form-f-label'>Country*</label>
                                            <Field name='country' component='select' disabled={true}
                                                   className='single-choice-selector'>
                                                {countryOpts.map(option => (
                                                    <option key={`country-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>

                                            <label className='form-f-label'>Address*</label>
                                            <Field
                                                name='address'
                                                component='input'
                                                className={errors.address && touched.address ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Address*'
                                                disabled={true}
                                                value={values.address}
                                            />

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>City*</label>
                                                    <Field
                                                        name='city'
                                                        component='input'
                                                        className={errors.city && touched.city ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='City*'
                                                        disabled={true}
                                                        value={values.city}
                                                    />
                                                </div>

                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <Field name='state' component='select' disabled={true}
                                                               className='state-selector' placeholder='State'>
                                                            {usStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                    </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Postal Code*</label>
                                                    <Field
                                                        name='postal'
                                                        component='input'
                                                        className={errors.postal && touched.postal ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Postal Code*'
                                                        disabled={true}
                                                        value={values.postal}
                                                    />
                                                </div>
                                            </div>

                                            <h5 className='profile-data-sub-section'>Company Mailing Address (if different from Billing Address above)</h5>

                                            <label className='form-f-label'>Country</label>
                                            <select
                                                name='mailing_country'
                                                className='single-choice-selector'
                                                value={values.mailing_country}
                                                disabled={true}
                                            >
                                                {countryOpts.map(option => (
                                                    <option key={`mailing_country-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </select>

                                            <label className='form-f-label'>Address</label>
                                            <input
                                                name='mailing_address'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Address'
                                                value={values.mailing_address}
                                                disabled={true}

                                        />

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>City</label>
                                                    <input
                                                        name='mailing_city'
                                                        className='form-f-field'
                                                        type='text'
                                                        placeholder='City'
                                                        value={values.mailing_city}
                                                        disabled={true}
                                                    />

                                                </div>

                                                {this.state.country === 'CA' ?
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State</label>
                                                        <select
                                                            name='mailing_state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={values.mailing_state}
                                                            disabled={true}
                                                        >
                                                            {caStateOpts.map(option => (
                                                                <option key={`mailing_state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>:
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State</label>
                                                        <select
                                                            name='mailing_state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={values.mailing_state}
                                                            disabled={true}
                                                        >
                                                            {usStateOpts.map(option => (
                                                                <option key={`mailing_state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                }

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Postal Code</label>
                                                    <input
                                                        name='mailing_postal'
                                                        className='form-f-field'
                                                        type='text'
                                                        placeholder='Postal Code'
                                                        value={values.mailing_postal}
                                                        disabled={true}
                                                    />
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Website*</label>
                                            <Field
                                                name='domain'
                                                component='input'
                                                className={errors.domain && touched.domain ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Website*'
                                                disabled={true}
                                                value={values.domain}
                                            />
                                            {errors.domain && touched.domain ?
                                                (<div className='f-field-errors'>{errors.domain}</div>) : null
                                            }

                                            <label className='form-f-label'>Year Established*</label>
                                            <Field
                                                name='established'
                                                component='input'
                                                className={errors.established && touched.established ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Year Established*'
                                                value={values.established}
                                                disabled={true}
                                            />
                                            {errors.established && touched.established ?
                                                (<div className='f-field-errors'>{errors.established}</div>) : null
                                            }

                                            <label className='form-f-label'>D&B/DUNS Number</label>
                                            <Field
                                                name='duns'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='D&B/DUNS Number'
                                                disabled={true}
                                                value={values.duns}
                                            />

                                            <label className='form-f-label'>Reseller Certification Number</label>
                                            <Field
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                name='reseller_certification'
                                                placeholder='Reseller Certification Number'
                                                disabled={true}
                                                value={values.reseller_certification}
                                            />

                                            <p className='disclaimer--copy'>Specify your reseller tax number and state
                                                above and upload a copy of your reseller certificate below.
                                                If you sell in multiple states, please upload them as a zip file. If no
                                                reseller certificate is provided, applicable sales tax will be charged
                                                on your purchases.</p>
                                            <br/>
                                            <section>
                                                <a className='edit-p-button' onClick={this.uploadResellerCertificate}>{this.state.uploadingCertificate ? 'Saving...' :  'Upload Certificate'}</a>
                                                <input name="onUploadUserFile" onChange={this.onUploadUserFile} style={{display: 'none'}} type="file" />
                                            </section>
                                            <br/>
                                            {this.state.companyD.reseller_certification_path !== undefined && this.state.companyD.reseller_certification_path !== "null"?
                                                <a className='edit-p-button' href={this.state.companyD.reseller_certification_path} target="_blank">View Certificate</a> : null
                                            }

                                            <label className='form-f-label'>Business Type*</label>
                                            <Field name='business_type' component='select' disabled={true}
                                                   className='single-choice-selector'>
                                                {businessOpts.map(option => (
                                                    <option key={`business_type-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>

                                            <label className='form-f-label'>Number of Stores/Branches</label>
                                            <Field
                                                name='number_of_stores'
                                                component='input'
                                                className={errors.number_of_stores && touched.number_of_stores ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Number of Stores/Branches'
                                                disabled={true}
                                                value={values.number_of_stores}
                                            />


                                            <h3 className='profile-data-section'>Contact Information</h3>

                                            <p className='disclaimer--copy'>Please provide appropriate contact information for the departments listed below.
                                                This will ensure we are communicating with the appropriate members of your business. </p>

                                            <h5 className='profile-data-sub-section'>Sales</h5>

                                            <label className='form-f-label'>Name*</label>
                                            <Field
                                                name='sales_name'
                                                className={errors.sales_name && touched.sales_name ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Name*'
                                                disabled={true}
                                                value={values.sales_name}/>

                                            <label className='form-f-label'>Phone*</label>
                                            <Field
                                                name='sales_phone'
                                                className={errors.sales_phone && touched.sales_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Phone*'
                                                disabled={true}
                                                value={values.sales_phone}/>

                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='sales_email'
                                                className={errors.sales_email && touched.sales_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                disabled={true}
                                                value={values.sales_email}/>

                                            <h5 className='profile-data-sub-section'>Accounts Payable</h5>

                                            <label className='form-f-label'>Name*</label>
                                            <Field
                                                name='accounts_name'
                                                className={errors.accounts_name && touched.accounts_name ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Name*'
                                                disabled={true}
                                                value={values.accounts_name}/>

                                            <label className='form-f-label'>Phone*</label>
                                            <Field
                                                name='accounts_phone'
                                                className={errors.accounts_phone && touched.accounts_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Phone*'
                                                disabled={true}
                                                value={values.accounts_phone}/>

                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='accounts_email'
                                                className={errors.accounts_email && touched.accounts_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                disabled={true}
                                                value={values.accounts_email}/>

                                            <h5 className='profile-data-sub-section'>Shipping & Logistics</h5>

                                            <label className='form-f-label'>Name*</label>
                                            <Field
                                                name='logistics_name'
                                                className={errors.logistics_name && touched.logistics_name ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Name*'
                                                disabled={true}
                                                value={values.logistics_name}/>

                                            <label className='form-f-label'>Phone*</label>
                                            <Field
                                                name='logistics_phone'
                                                className={errors.logistics_phone && touched.logistics_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Phone*'
                                                disabled={true}
                                                value={values.logistics_phone}/>

                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='logistics_email'
                                                className={errors.logistics_email && touched.logistics_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                disabled={true}
                                                value={values.logistics_email}/>

                                            <h3 className='profile-data-section'>Bank & Credit References</h3>

                                            <p className='disclaimer--copy'>If you would like credit terms to be extended to your business please provide your bank and credit reference(s) for credit review by NOON.
                                                If no credit needs to be extended (i.e., paying by credit card) please leave blank.</p>

                                            <h5 className='profile-data-sub-section'>Bank Reference</h5>

                                            <label className='form-f-label'>Bank Name</label>
                                            <Field
                                                name='bank_name'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Name'
                                                disabled={true}
                                                value={values.bank_name}/>


                                            <label className='form-f-label'>Bank Address</label>
                                            <Field
                                                name='bank_address'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Address'
                                                disabled={true}
                                                value={values.bank_address}/>

                                            <label className='form-f-label'>Bank Contact Representative</label>
                                            <Field
                                                name='bank_representative'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Contact Representative'
                                                disabled={true}
                                                value={values.bank_representative}/>

                                            <label className='form-f-label'>Bank Contact Phone Number</label>
                                            <Field
                                                name='bank_phone'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Contact Phone Number'
                                                disabled={true}
                                                value={values.bank_phone}/>

                                            <label className='form-f-label'>Bank Contact Email</label>
                                            <Field
                                                name='bank_email'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Contact Email'
                                                disabled={true}
                                                value={values.bank_email}/>

                                            <h5 className='profile-data-sub-section'>Credit Reference #1</h5>

                                            <label className='form-f-label'>Company Name</label>
                                            <Field
                                                name='first_creditref_name'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Name'
                                                disabled={true}
                                                value={values.first_creditref_name}/>


                                            <label className='form-f-label'>Company Address</label>
                                            <Field
                                                name='first_creditref_address'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Address'
                                                disabled={true}
                                                value={values.first_creditref_address}/>

                                            <label className='form-f-label'>Company Contact Representative</label>

                                            <Field
                                                name='first_creditref_representative'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Representative'
                                                disabled={true}
                                                value={values.first_creditref_representative}/>

                                            <label className='form-f-label'>Company Contact Phone Number</label>
                                            <Field
                                                name='first_creditref_phone'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Phone Number'
                                                disabled={true}
                                                value={values.first_creditref_phone}/>

                                            <label className='form-f-label'>Company Contact Email</label>
                                            <Field
                                                name='first_creditref_email'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Email'
                                                disabled={true}
                                                value={values.first_creditref_email}/>

                                            <h5 className='profile-data-sub-section'>Credit Reference #2</h5>

                                            <label className='form-f-label'>Company Name</label>
                                            <Field
                                                name='second_creditref_name'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Name'
                                                disabled={true}
                                                value={values.second_creditref_name}/>


                                            <label className='form-f-label'>Company Address</label>
                                            <Field
                                                name='second_creditref_address'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Address'
                                                disabled={true}
                                                value={values.second_creditref_address}/>

                                            <label className='form-f-label'>Company Contact Representative</label>

                                            <Field
                                                name='second_creditref_representative'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Representative'
                                                disabled={true}
                                                value={values.second_creditref_representative}/>

                                            <label className='form-f-label'>Company Contact Phone Number</label>
                                            <Field
                                                name='second_creditref_phone'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Phone Number'
                                                disabled={true}
                                                value={values.second_creditref_phone}/>

                                            <label className='form-f-label'>Company Contact Email</label>
                                            <Field
                                                name='second_creditref_email'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Email'
                                                disabled={true}
                                                value={values.second_creditref_email}/>

                                            <h3 className='profile-data-section'>Coverage Information</h3>
                                            <label className='form-f-label'>Coverage Segments*</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='coverage_segments'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {segmentOps.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            disabled={true}
                                                                            name='coverage_segments'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.coverage_segments.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.coverage_segments.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Services Offered*</label>

                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='services_offered'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {servicesOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            disabled={true}
                                                                            name='services_offered'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.services_offered.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.services_offered.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Number of Employees*</label>
                                            <Field
                                                name='number_of_employees'
                                                component='input'
                                                className={errors.number_of_employees && touched.number_of_employees ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Number of Employees*'
                                                disabled={true}
                                                value={values.number_of_employees}
                                            />

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='dealer_finder'
                                                    checked={values.dealer_finder}
                                                    readOnly={true}
                                                />
                                                <p className='toggle-in-label'>Add to NOON Finder?</p>
                                            </div>
                                            <br/>
                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='provide_staff_training'
                                                    checked={values.provide_staff_training}
                                                    readOnly={true}
                                                />
                                                <p className='toggle-in-label'>Can NOON provide training of staff?</p>
                                            </div>


                                            <h3 className='profile-data-section'>Additional Information</h3>

                                            <label className='form-f-label'> How you heard about NOON?</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='additional_information_hearAboutNoon'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {refferalOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            disabled={true}
                                                                            name='additional_information_hearAboutNoon'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.additional_information_hearAboutNoon.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.additional_information_hearAboutNoon.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            <div className='toggle-switch-gr'>
                                                <input

                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='experience_with_noon'
                                                    checked={values.experience_with_noon}
                                                    readOnly={true}
                                                />
                                                <p className='toggle-in-label'>Do you have Experience installing
                                                    NOON?</p>
                                            </div>

                                        </Form>
                                    )}
                                </Formik>
                            }
                        </div>
                    </div>:
                    <Loader/>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/routes/UserProfile/DistributorProfile.js